import React from 'react';
import { Spin } from 'antd';

export class Loading extends React.Component {
  render() {
    return (<div className='loading' style={this.props.style}><Spin /></div>)
  }
}


// WEBPACK FOOTER //
// ./src/components/utils/loading.js